import { lazy } from 'react';
import ComponentLoader from 'src/components/ComponentLoader';
import Module from 'src/config/models/Module';
import ModuleBundle from 'src/config/models/ModuleBundle';

export const StationDashboardModule = new Module({
  id: 'STATION_DASHBOARD:VIEW:*',
  name: 'Production Station Analytics',
  label: 'Station Dashboard',
  path: 'station-dashboard',
  Component: ComponentLoader(
    lazy(() => import('src/content/reports/SessionReport/StationDashboard'))
  ),
  actions: {
    exportData: {
      id: 'STATION_DASHBOARD:ACTION:EXPORT_DATA',
      name: 'export-data',
      label: 'Export Data'
    }
  }
});

export const StationReportModule = StationDashboardModule;

const StationDashboardModules = [StationDashboardModule];

export default new ModuleBundle('StationDashboard', StationDashboardModules);
